import { render, staticRenderFns } from "./RelatedContent.vue?vue&type=template&id=512216dd&scoped=true"
import script from "./RelatedContent.vue?vue&type=script&lang=js"
export * from "./RelatedContent.vue?vue&type=script&lang=js"
import style0 from "./RelatedContent.vue?vue&type=style&index=0&id=512216dd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "512216dd",
  null
  
)

export default component.exports